import { types } from "mobx-state-tree"

export const StripeSubscriptionModel = types.model("StripeSubscription").props({
  id: types.string,
  name: types.maybeNull(types.string),
  status: types.string,
  price: types.number,
  currency: types.string,
  created: types.maybeNull(types.integer),
  currentPeriodStart: types.maybeNull(types.integer),
  currentPeriodEnd: types.maybeNull(types.integer),
  cancelAtPeriodEnd: types.maybeNull(types.boolean),
  endedAt: types.maybeNull(types.integer),
  cancelAt: types.maybeNull(types.integer),
  trialStart: types.maybeNull(types.integer),
  trialEnd: types.maybeNull(types.integer),
  discountDuration: types.maybeNull(types.string), // `forever`, `once`, or `repeating`
  discountDurationInMonths: types.maybeNull(types.integer), // when `discountDuration=repeating`
  discountStart: types.maybeNull(types.integer),
  discountEnd: types.maybeNull(types.integer),
  discountPrice: types.maybeNull(types.integer),
  discountPercentOff: types.maybeNull(types.integer),
  discountAmountOff: types.maybeNull(types.integer),
  unpaidInvoiceAmount: types.maybeNull(types.integer),
  unpaidInvoiceNextPaymentAttempt: types.maybeNull(types.integer),
  /**
   * The current balance, if any, that's stored on the customer.
   * If negative, the customer has credit to apply to their next invoice.
   * If positive, the customer has an amount owed that's added to their next invoice.
   * The balance only considers amounts that Stripe hasn't successfully applied to any invoice.
   * It doesn't reflect unpaid invoices.
   * This balance is only taken into account after invoices finalize.
   */
  balance: types.maybeNull(types.integer),
  defaultPaymentMethodId: types.maybeNull(types.string),
  // subscription for user that registered before paid subscription was released
  isEarlyAdopter: types.maybeNull(types.boolean),
})
